<div class="db-create-website-trial__header">
  <h2 class="db-create-website-trial__title">{{ 'text_createANewWordpressWebsite' | dbText}}</h2>
  <p class="db-create-website-trial__desc" [innerHTML]="'text_buildYourWebsiteUsingAnyThemePluginBuilderAndAiAssistance' | dbText:{companyName: companyName}"></p>
</div>

<form class="db-create-website-trial__body" [formGroup]="createWebsiteForm" (ngSubmit)="submit()">
  <div class="ds-input-wrap mb8">
    <ds-dropdown [dsDropdownOptions]="regions" formControlName="region"
                 [dsDropdownDisabled]="userSubscription?.type === UserSubscriptionCategory.DedicatedVM"
                 [dsDropdownLabel]="('text_regionDescription' | dbText)"></ds-dropdown>
  </div>

  <div class="ds-input-wrap mb8">
    <span class="ds-input-label">{{ 'text_siteTitle' | dbText}}</span>
    <input type="text" class="ds-input" [class.error]="formSubmitted && createWebsiteForm?.get('websiteTitle')?.errors"
           placeholder="Jim's blog" maxlength="255" formControlName="websiteTitle">
    <span *ngIf="formSubmitted && createWebsiteForm?.get('websiteTitle')?.errors" class="ds-input-error-msg"
          [innerHTML]="createWebsiteForm?.get('websiteTitle')?.errors['required'] ?
            'This field is required.' : ''"></span>
  </div>
  <div class="db-create-website-trial__footer">
    <div class="db-create-website-trial__footer-sites-count">
      <p>{{ 'text_hostedSites' | dbText }}</p>
          <b>{{hostedWebsitesCount}} {{ 'text_of' | dbText }} {{hostedWebsitesLimit}}</b>
    </div>
    <div class="db-website-install__btn-wrap">
      <button class="ds-btn-blue" type="submit">
        <span>{{ 'text_create' | dbText }}</span>
      </button>
    </div>
  </div>

</form>
